const actionTypes = {
  setAwsConnectionStatus: 'SET_AWS_CONNECTION_STATUS',
  setDisplayOnlyRequiredInfoFields: 'SET_DISPLAY_ONLY_REQUIRED',
  setCurrentTrialName: 'SET_CURRENT_TRIAL_NAME',
  setCurrentLibraryId: 'SET_CURRENT_LIBRARY_ID',
  setCurrentLibraryName: 'SET_CURRENT_LIBRARY_NAME',
  setCurrentCollectionId: 'SET_CURRENT_COLLECTION_ID',
  setCurrentCollectionName: 'SET_CURRENT_COLLECTION_NAME',
  setAuthenticityToken: 'SET_AUTHENTICITY_TOKEN',
  setNotificationDomRef: 'SET_NOTIFICATION_DOM_REF',
  setConfirmDialogCompleted: 'SET_CONFIRM_DIALOG_COMPLETED',
  setActiveAccordionIndex: 'SET_ACTIVE_ACCORDION_INDEX',
  addHeartbeatId: 'ADD_HEARTBEAT_ID',
  removeHeartbeatId: 'REMOVE_HEARTBEAT_ID',
};

export default actionTypes;
